import { useRouteError } from 'react-router-dom';

import { ErrorCritical } from '@packages/fenrir/feedback/errors/error-critical';
import { ErrorMessage } from '@packages/fenrir/feedback/errors/error-message';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

const InternalErrorMessage = () => {
  const error: any = useRouteError();

  return (
    <ErrorMessage>
      {error.message}
      <br />
      {error.stack}
    </ErrorMessage>
  );
};

export const UnifiedPortalCriticalErrorPage = () => {
  const errorMessage = import.meta.env.DEV ? (
    <InternalErrorMessage />
  ) : undefined;

  return (
    <PagePlain>
      <PageContainerRoot>
        <ErrorCritical errorMessages={errorMessage} />
      </PageContainerRoot>
    </PagePlain>
  );
};
